class TextReadMore extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-read-more-content]');
    this.toggle = this.querySelector('[data-read-more-toggle]');
    if (!this.content || !this.toggle) return;

    this.lines = Math.max(1, Number.parseInt(this.dataset.lines || '4', 10) || 4);
    this.dataset.ready = 'true';
    this.dataset.expanded = 'false';

    this.onToggle = () => {
      const expanded = this.dataset.expanded !== 'true';
      this.dataset.expanded = String(expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.querySelector('[data-read-more-label]').hidden = expanded;
      this.querySelector('[data-see-less-label]').hidden = !expanded;
    };
    this.toggle.addEventListener('click', this.onToggle);

    this.onResize = ([entry]) => {
      const width = entry.contentRect.width;
      if (Math.abs(width - (this.lastWidth ?? -1)) > 0.5) {
        this.lastWidth = width;
        this.updateOverflow();
      }
    };
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.content);
    this.updateOverflow();
    document.fonts?.ready.then(() => {
      if (this.isConnected) this.updateOverflow();
    });
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.toggle?.removeEventListener('click', this.onToggle);
  }

  updateOverflow() {
    if (!this.content || !this.toggle) return;

    const wasExpanded = this.dataset.expanded === 'true';
    this.dataset.expanded = 'true';
    const contentTop = this.content.getBoundingClientRect().top;
    const linePositions = [];
    const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.textContent?.trim()) continue;
      const range = document.createRange();
      range.selectNodeContents(node);
      for (const rect of range.getClientRects()) {
        if (rect.height > 0 && !linePositions.some((line) => Math.abs(line.top - rect.top) < 1)) {
          linePositions.push({ top: rect.top, bottom: rect.bottom });
        }
      }
    }

    linePositions.sort((a, b) => a.top - b.top);
    const hasOverflow = linePositions.length > this.lines;
    if (hasOverflow) {
      const lastVisibleLine = linePositions[this.lines - 1];
      this.style.setProperty('--read-more-max-height', `${Math.ceil(lastVisibleLine.bottom - contentTop + 1)}px`);
    }

    this.dataset.expanded = String(wasExpanded && hasOverflow);
    this.toggle.hidden = !hasOverflow;
    this.toggle.setAttribute('aria-expanded', String(wasExpanded && hasOverflow));
    this.querySelector('[data-read-more-label]').hidden = wasExpanded && hasOverflow;
    this.querySelector('[data-see-less-label]').hidden = !(wasExpanded && hasOverflow);
  }
}

if (!customElements.get('text-read-more')) {
  customElements.define('text-read-more', TextReadMore);
}
